/* eslint-disable @typescript-eslint/ban-ts-comment */
import { all, takeLatest } from "redux-saga/effects";

import { signIn } from "./auth/sagas";
import { LoginTypes } from "./auth/types";

export default function* rootSaga(): any {
  return yield all([
    // @ts-ignore
    takeLatest(LoginTypes.SIGN_IN_REQUEST, signIn),
  ]);
}
